import React, { FC, MouseEvent, PropsWithChildren, ReactElement } from 'react';

import classNames from 'classnames';

export const TextButton: FC<
  PropsWithChildren<{
    extraAttributes?: object;
    icon?: string;
    reverse?: boolean;
    uppercase?: boolean;
    onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    absolute?: boolean;
  }>
> = ({
  children,
  icon,
  reverse = false,
  uppercase = false,
  onClick,
  disabled = false,
  absolute = false,
  extraAttributes
}) => (
  <button
    {...extraAttributes}
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={classNames(
      'tw-group tw-flex tw-items-center tw-gap-1 tw-whitespace-nowrap tw-rounded tw-text-raa-orange hover:tw-text-raa-orange-hover focus:tw-bg-raa-orange focus:tw-text-raa-white focus:tw-outline-transparent',
      {
        'tw-flex-row-reverse': reverse,
        'tw-uppercase': uppercase,
        '!group-hover:tw-no-underline !tw-text-raa-gray-4': disabled,
        'tw-absolute': absolute
      }
    )}
  >
    {icon && <span aria-hidden="true" className={`raa-icon !tw-no-underline ${icon}`} />}
    <span
      className={classNames('tw-text-left group-hover:tw-underline', {
        'group-hover:tw-no-underline': disabled
      })}
    >
      {children}
    </span>
  </button>
);

export const ExternalLink: FC<{ href: string; text: string; target?: string; beforeNavigation?: () => void }> = ({
  href,
  text,
  target = '_blank',
  beforeNavigation
}) => {
  const handleBeforeNavigation = (event: MouseEvent<HTMLAnchorElement>) => {
    if (beforeNavigation) {
      event.preventDefault();
      beforeNavigation();
    }
  };

  return (
    <div className="tw-flex">
      <a
        href={href}
        onClick={handleBeforeNavigation}
        className="raa-link tw-select-none"
        rel="noopener noreferrer"
        target={target}
      >
        <span className="raa-icon-externallink raa-icon tw-mr-1" />
        <span>{text}</span>
      </a>
    </div>
  );
};

interface ButtonListProps {
  items: Array<any>;
  selectedItem: (item: any) => void;
  displayAttr: string;
  disabledKey?: string;
  valueAttr: string;
}

export const ButtonList = (props: ButtonListProps): ReactElement => {
  return (
    <ul className="tw-overflow-auto">
      {props.items.map((item, index: number) => (
        <li className="tw-border-gray-200 tw-border tw-border-b-0 last:tw-border-b" key={index}>
          <button
            className={`tw-flex tw-w-full tw-items-center tw-justify-between tw-px-2 tw-py-2 ${
              props.disabledKey === item[props.valueAttr] ? 'tw-text-raa-gray-4' : ''
            }`}
            disabled={props.disabledKey === item[props.valueAttr] || new Date(item.expires_at).getTime() < Date.now()}
            onClick={() => props.selectedItem(item)}
          >
            {item[props.displayAttr]}
            <span className="raa-icon raa-icon-arrow-right tw-text-size-2.5" />
          </button>
        </li>
      ))}
    </ul>
  );
};
